import React, { useState, useEffect } from 'react';
import Animation from '../../assets/images/ezgif.com-animated-gif-maker.gif'
import ImgLogo from '../../assets/images/LOGO TRANSPARENT.png'
import BenIce10 from '../../assets/images/motion/Ben_Ice_00010.jpg'
import BenIce11 from '../../assets/images/motion/Ben_Ice_00011.jpg'
import BenIce12 from '../../assets/images/motion/Ben_Ice_00012.jpg'
import BenIce13 from '../../assets/images/motion/Ben_Ice_00013.jpg'
import BenIce14 from '../../assets/images/motion/Ben_Ice_00014.jpg'
import BenIce15 from '../../assets/images/motion/Ben_Ice_00015.jpg'
import BenIce16 from '../../assets/images/motion/Ben_Ice_00016.jpg'
import BenIce17 from '../../assets/images/motion/Ben_Ice_00017.jpg'
import BenIce18 from '../../assets/images/motion/Ben_Ice_00018.jpg'
import BenIce19 from '../../assets/images/motion/Ben_Ice_00019.jpg'
import BenIce20 from '../../assets/images/motion/Ben_Ice_00020.jpg'
import BenIce21 from '../../assets/images/motion/Ben_Ice_00021.jpg'
import BenIce22 from '../../assets/images/motion/Ben_Ice_00022.jpg'
import BenIce23 from '../../assets/images/motion/Ben_Ice_00023.jpg'
import BenIce24 from '../../assets/images/motion/Ben_Ice_00024.jpg'
import BenIce25 from '../../assets/images/motion/Ben_Ice_00025.jpg'
import BenIce26 from '../../assets/images/motion/Ben_Ice_00026.jpg'
import BenIce27 from '../../assets/images/motion/Ben_Ice_00027.jpg'
import BenIce28 from '../../assets/images/motion/Ben_Ice_00028.jpg'
import BenIce29 from '../../assets/images/motion/Ben_Ice_00029.jpg'
import BenIce30 from '../../assets/images/motion/Ben_Ice_00030.jpg'
import BenIce31 from '../../assets/images/motion/Ben_Ice_00031.jpg'
import BenIce32 from '../../assets/images/motion/Ben_Ice_00032.jpg'
import BenIce33 from '../../assets/images/motion/Ben_Ice_00033.jpg'
import BenIce34 from '../../assets/images/motion/Ben_Ice_00034.jpg'
import BenIce35 from '../../assets/images/motion/Ben_Ice_00035.jpg'
import BenIce36 from '../../assets/images/motion/Ben_Ice_00036.jpg'
import BenIce37 from '../../assets/images/motion/Ben_Ice_00037.jpg'
import BenIce38 from '../../assets/images/motion/Ben_Ice_00038.jpg'
import BenIce39 from '../../assets/images/motion/Ben_Ice_00039.jpg'
import BenIce40 from '../../assets/images/motion/Ben_Ice_00040.jpg'
import BenIce41 from '../../assets/images/motion/Ben_Ice_00041.jpg'
import BenIce42 from '../../assets/images/motion/Ben_Ice_00042.jpg'
import BenIce43 from '../../assets/images/motion/Ben_Ice_00043.jpg'
import BenIce44 from '../../assets/images/motion/Ben_Ice_00044.jpg'
import BenIce45 from '../../assets/images/motion/Ben_Ice_00045.jpg'
import BenIce46 from '../../assets/images/motion/Ben_Ice_00046.jpg'
import BenIce47 from '../../assets/images/motion/Ben_Ice_00047.jpg'
import BenIce48 from '../../assets/images/motion/Ben_Ice_00048.jpg'
import BenIce49 from '../../assets/images/motion/Ben_Ice_00049.jpg'
import BenIce50 from '../../assets/images/motion/Ben_Ice_00050.jpg'
import BenIce51 from '../../assets/images/motion/Ben_Ice_00051.jpg'
import BenIce52 from '../../assets/images/motion/Ben_Ice_00052.jpg'
import BenIce53 from '../../assets/images/motion/Ben_Ice_00053.jpg'
import BenIce54 from '../../assets/images/motion/Ben_Ice_00054.jpg'
import BenIce55 from '../../assets/images/motion/Ben_Ice_00055.jpg'
import BenIce56 from '../../assets/images/motion/Ben_Ice_00056.jpg'
import BenIce57 from '../../assets/images/motion/Ben_Ice_00057.jpg'
import BenIce58 from '../../assets/images/motion/Ben_Ice_00058.jpg'
import BenIce59 from '../../assets/images/motion/Ben_Ice_00059.jpg'
import BenIce60 from '../../assets/images/motion/Ben_Ice_00060.jpg'
import BenIce61 from '../../assets/images/motion/Ben_Ice_00061.jpg'
import BenIce62 from '../../assets/images/motion/Ben_Ice_00062.jpg'
import BenIce63 from '../../assets/images/motion/Ben_Ice_00063.jpg'
import BenIce64 from '../../assets/images/motion/Ben_Ice_00064.jpg'
import BenIce65 from '../../assets/images/motion/Ben_Ice_00065.jpg'
import BenIce66 from '../../assets/images/motion/Ben_Ice_00066.jpg'
import BenIce67 from '../../assets/images/motion/Ben_Ice_00067.jpg'
import BenIce68 from '../../assets/images/motion/Ben_Ice_00068.jpg'
import BenIce69 from '../../assets/images/motion/Ben_Ice_00069.jpg'
import BenIce70 from '../../assets/images/motion/Ben_Ice_00070.jpg'
import BenIce71 from '../../assets/images/motion/Ben_Ice_00071.jpg'
import BenIce72 from '../../assets/images/motion/Ben_Ice_00072.jpg'
import BenIce73 from '../../assets/images/motion/Ben_Ice_00073.jpg'
import BenIce74 from '../../assets/images/motion/Ben_Ice_00074.jpg'
import BenIce75 from '../../assets/images/motion/Ben_Ice_00075.jpg'
import BenIce76 from '../../assets/images/motion/Ben_Ice_00076.jpg'
import BenIce77 from '../../assets/images/motion/Ben_Ice_00077.jpg'
import BenIce78 from '../../assets/images/motion/Ben_Ice_00078.jpg'
import BenIce79 from '../../assets/images/motion/Ben_Ice_00079.jpg'
import BenIce80 from '../../assets/images/motion/Ben_Ice_00080.jpg'
import BenIce81 from '../../assets/images/motion/Ben_Ice_00081.jpg'
import BenIce82 from '../../assets/images/motion/Ben_Ice_00082.jpg'
import BenIce83 from '../../assets/images/motion/Ben_Ice_00083.jpg'
import BenIce84 from '../../assets/images/motion/Ben_Ice_00084.jpg'
import BenIce85 from '../../assets/images/motion/Ben_Ice_00085.jpg'
import BenIce86 from '../../assets/images/motion/Ben_Ice_00086.jpg'
import BenIce87 from '../../assets/images/motion/Ben_Ice_00087.jpg'
import BenIce88 from '../../assets/images/motion/Ben_Ice_00088.jpg'
import BenIce89 from '../../assets/images/motion/Ben_Ice_00089.jpg'
import BenIce90 from '../../assets/images/motion/Ben_Ice_00090.jpg'
import BenIce91 from '../../assets/images/motion/Ben_Ice_00091.jpg'
import BenIce92 from '../../assets/images/motion/Ben_Ice_00092.jpg'
import BenIce93 from '../../assets/images/motion/Ben_Ice_00093.jpg'
import BenIce94 from '../../assets/images/motion/Ben_Ice_00094.jpg'
import BenIce95 from '../../assets/images/motion/Ben_Ice_00095.jpg'
import BenIce96 from '../../assets/images/motion/Ben_Ice_00096.jpg'
import BenIce97 from '../../assets/images/motion/Ben_Ice_00097.jpg'
import BenIce98 from '../../assets/images/motion/Ben_Ice_00098.jpg'
import BenIce99 from '../../assets/images/motion/Ben_Ice_00099.jpg'
import BenIce100 from '../../assets/images/motion/Ben_Ice_00100.jpg'
import BenIce101 from '../../assets/images/motion/Ben_Ice_00101.jpg'
import BenIce102 from '../../assets/images/motion/Ben_Ice_00102.jpg'
import BenIce103 from '../../assets/images/motion/Ben_Ice_00103.jpg'
import BenIce104 from '../../assets/images/motion/Ben_Ice_00104.jpg'
import BenIce105 from '../../assets/images/motion/Ben_Ice_00105.jpg'
import BenIce106 from '../../assets/images/motion/Ben_Ice_00106.jpg'
import BenIce107 from '../../assets/images/motion/Ben_Ice_00107.jpg'
import BenIce108 from '../../assets/images/motion/Ben_Ice_00108.jpg'
import BenIce109 from '../../assets/images/motion/Ben_Ice_00109.jpg'



import BenIce110 from '../../assets/images/motion/Ben_Ice_00110.jpg'
import BenIce111 from '../../assets/images/motion/Ben_Ice_00111.jpg'
import BenIce112 from '../../assets/images/motion/Ben_Ice_00112.jpg'
import BenIce113 from '../../assets/images/motion/Ben_Ice_00113.jpg'
import BenIce114 from '../../assets/images/motion/Ben_Ice_00114.jpg'
import BenIce115 from '../../assets/images/motion/Ben_Ice_00115.jpg'
import BenIce116 from '../../assets/images/motion/Ben_Ice_00116.jpg'
import BenIce117 from '../../assets/images/motion/Ben_Ice_00117.jpg'
import BenIce118 from '../../assets/images/motion/Ben_Ice_00118.jpg'
import BenIce119 from '../../assets/images/motion/Ben_Ice_00119.jpg'
import BenIce120 from '../../assets/images/motion/Ben_Ice_00120.jpg'
import BenIce121 from '../../assets/images/motion/Ben_Ice_00121.jpg'
import BenIce122 from '../../assets/images/motion/Ben_Ice_00122.jpg'
import BenIce123 from '../../assets/images/motion/Ben_Ice_00123.jpg'
import BenIce124 from '../../assets/images/motion/Ben_Ice_00124.jpg'
import BenIce125 from '../../assets/images/motion/Ben_Ice_00125.jpg'
import BenIce126 from '../../assets/images/motion/Ben_Ice_00126.jpg'
import BenIce127 from '../../assets/images/motion/Ben_Ice_00127.jpg'
import BenIce128 from '../../assets/images/motion/Ben_Ice_00128.jpg'
import BenIce129 from '../../assets/images/motion/Ben_Ice_00129.jpg'
import BenIce130 from '../../assets/images/motion/Ben_Ice_00130.jpg'
import BenIce131 from '../../assets/images/motion/Ben_Ice_00131.jpg'
import BenIce132 from '../../assets/images/motion/Ben_Ice_00132.jpg'
import BenIce133 from '../../assets/images/motion/Ben_Ice_00133.jpg'
import BenIce134 from '../../assets/images/motion/Ben_Ice_00134.jpg'
import BenIce135 from '../../assets/images/motion/Ben_Ice_00135.jpg'
import BenIce136 from '../../assets/images/motion/Ben_Ice_00136.jpg'
import BenIce137 from '../../assets/images/motion/Ben_Ice_00137.jpg'
import BenIce138 from '../../assets/images/motion/Ben_Ice_00138.jpg'
import BenIce139 from '../../assets/images/motion/Ben_Ice_00139.jpg'
import BenIce140 from '../../assets/images/motion/Ben_Ice_00140.jpg'
import BenIce141 from '../../assets/images/motion/Ben_Ice_00141.jpg'
import BenIce142 from '../../assets/images/motion/Ben_Ice_00142.jpg'
import BenIce143 from '../../assets/images/motion/Ben_Ice_00143.jpg'
import BenIce144 from '../../assets/images/motion/Ben_Ice_00144.jpg'
import BenIce145 from '../../assets/images/motion/Ben_Ice_00145.jpg'
import BenIce146 from '../../assets/images/motion/Ben_Ice_00146.jpg'
import BenIce147 from '../../assets/images/motion/Ben_Ice_00147.jpg'
import BenIce148 from '../../assets/images/motion/Ben_Ice_00148.jpg'
import BenIce149 from '../../assets/images/motion/Ben_Ice_00149.jpg'
import BenIce150 from '../../assets/images/motion/Ben_Ice_00150.jpg'
import BenIce151 from '../../assets/images/motion/Ben_Ice_00151.jpg'
import BenIce152 from '../../assets/images/motion/Ben_Ice_00152.jpg'
import BenIce153 from '../../assets/images/motion/Ben_Ice_00153.jpg'
import BenIce154 from '../../assets/images/motion/Ben_Ice_00154.jpg'
import BenIce155 from '../../assets/images/motion/Ben_Ice_00155.jpg'
import BenIce156 from '../../assets/images/motion/Ben_Ice_00156.jpg'
import BenIce157 from '../../assets/images/motion/Ben_Ice_00157.jpg'
import BenIce158 from '../../assets/images/motion/Ben_Ice_00158.jpg'
import BenIce159 from '../../assets/images/motion/Ben_Ice_00159.jpg'
import BenIce160 from '../../assets/images/motion/Ben_Ice_00160.jpg'
import BenIce161 from '../../assets/images/motion/Ben_Ice_00161.jpg'
import BenIce162 from '../../assets/images/motion/Ben_Ice_00162.jpg'
import BenIce163 from '../../assets/images/motion/Ben_Ice_00163.jpg'
import BenIce164 from '../../assets/images/motion/Ben_Ice_00164.jpg'
import BenIce165 from '../../assets/images/motion/Ben_Ice_00165.jpg'
import BenIce166 from '../../assets/images/motion/Ben_Ice_00166.jpg'
import BenIce167 from '../../assets/images/motion/Ben_Ice_00167.jpg'
import BenIce168 from '../../assets/images/motion/Ben_Ice_00168.jpg'
import BenIce169 from '../../assets/images/motion/Ben_Ice_00169.jpg'
import BenIce170 from '../../assets/images/motion/Ben_Ice_00170.jpg'
import BenIce171 from '../../assets/images/motion/Ben_Ice_00171.jpg'
import BenIce172 from '../../assets/images/motion/Ben_Ice_00172.jpg'
import BenIce173 from '../../assets/images/motion/Ben_Ice_00173.jpg'
import BenIce174 from '../../assets/images/motion/Ben_Ice_00174.jpg'
import BenIce175 from '../../assets/images/motion/Ben_Ice_00175.jpg'
import BenIce176 from '../../assets/images/motion/Ben_Ice_00176.jpg'
import BenIce177 from '../../assets/images/motion/Ben_Ice_00177.jpg'
import BenIce178 from '../../assets/images/motion/Ben_Ice_00178.jpg'
import BenIce179 from '../../assets/images/motion/Ben_Ice_00179.jpg'
import BenIce180 from '../../assets/images/motion/Ben_Ice_00180.jpg'
import BenIce181 from '../../assets/images/motion/Ben_Ice_00181.jpg'
import BenIce182 from '../../assets/images/motion/Ben_Ice_00182.jpg'
import BenIce183 from '../../assets/images/motion/Ben_Ice_00183.jpg'
import BenIce184 from '../../assets/images/motion/Ben_Ice_00184.jpg'
import BenIce185 from '../../assets/images/motion/Ben_Ice_00185.jpg'
import BenIce186 from '../../assets/images/motion/Ben_Ice_00186.jpg'
import BenIce187 from '../../assets/images/motion/Ben_Ice_00187.jpg'
import BenIce188 from '../../assets/images/motion/Ben_Ice_00188.jpg'
import BenIce189 from '../../assets/images/motion/Ben_Ice_00189.jpg'
import BenIce190 from '../../assets/images/motion/Ben_Ice_00190.jpg'



const ImageAnimation = () => {
  const [frame, setFrame] = useState(0);

  const images = [
    BenIce10, BenIce11, BenIce12, BenIce13, BenIce14, BenIce15, BenIce16, BenIce17, BenIce18, BenIce19, BenIce20,
    BenIce21, BenIce22, BenIce23, BenIce24, BenIce25, BenIce26, BenIce27, BenIce28, BenIce29, BenIce30,
    BenIce31, BenIce32, BenIce33, BenIce34, BenIce35, BenIce36, BenIce37, BenIce38, BenIce39, BenIce40,
    BenIce41, BenIce42, BenIce43, BenIce44, BenIce45, BenIce46, BenIce47, BenIce48, BenIce49, BenIce50,
    BenIce51, BenIce52, BenIce53, BenIce54, BenIce55, BenIce56, BenIce57, BenIce58, BenIce59, BenIce60,
    BenIce61, BenIce62, BenIce63, BenIce64, BenIce65, BenIce66, BenIce67, BenIce68, BenIce69, BenIce70,
    BenIce71, BenIce72, BenIce73, BenIce74, BenIce75, BenIce76, BenIce77, BenIce78, BenIce79, BenIce80,
    BenIce81, BenIce82, BenIce83, BenIce84, BenIce85, BenIce86, BenIce87, BenIce88, BenIce89, BenIce90,
    BenIce91, BenIce92, BenIce93, BenIce94, BenIce95, BenIce96, BenIce97, BenIce98, BenIce99, BenIce100,
    BenIce101, BenIce102, BenIce103, BenIce104, BenIce105, BenIce106, BenIce107, BenIce108, BenIce109,
    BenIce110, BenIce111, BenIce112, BenIce113, BenIce114, BenIce115, BenIce116, BenIce117, BenIce118, BenIce119, BenIce120,
    BenIce121, BenIce122, BenIce123, BenIce124, BenIce125, BenIce126, BenIce127, BenIce128, BenIce129, BenIce130,
    BenIce131, BenIce132, BenIce133, BenIce134, BenIce135, BenIce136, BenIce137, BenIce138, BenIce139, BenIce140,
    BenIce141, BenIce142, BenIce143, BenIce144, BenIce145, BenIce146, BenIce147, BenIce148, BenIce149, BenIce150,
    BenIce151, BenIce152, BenIce153, BenIce154, BenIce155, BenIce156, BenIce157, BenIce158, BenIce159, BenIce160,
    BenIce161, BenIce162, BenIce163, BenIce164, BenIce165, BenIce166, BenIce167, BenIce168, BenIce169, BenIce170,
    BenIce171, BenIce172, BenIce173, BenIce174, BenIce175, BenIce176, BenIce177, BenIce178, BenIce179, BenIce180,
    BenIce181, BenIce182, BenIce183, BenIce184, BenIce185, BenIce186, BenIce187, BenIce188, BenIce189, BenIce190
  ]; // تمام عکس‌ها را در این آرایه قرار دهید

  // این تابع برای درخواست هر فریم جدید از مرورگر استفاده می‌کند
  const updateFrame = () => {
    setFrame((prevFrame) => (prevFrame + 1) % images.length);
    requestAnimationFrame(updateFrame); // درخواست فریم بعدی
  };

  useEffect(() => {
    // شروع انیمیشن با استفاده از requestAnimationFrame
    requestAnimationFrame(updateFrame);
    
    return () => {
      // هیچ نیازی به پاک کردن چیزی نیست چون مرورگر خودش مدیریت می‌کند
    };
  }, []);

  return (
    <div id="image-animation">
      <img src={Animation} alt="Animation Frame" className='mx-auto' width={400}/>
    </div>
  );
};

export default ImageAnimation;
